// AutoMapper
import { AutoMap } from '@nartc/automapper';

import { Type } from 'class-transformer';

// ViewModel
import { ClientPolicyControlExceptionModelVm } from 'app/_mapper/clientpolicycontrolexception.vm';
import { HelpPlanVm } from 'app/_mapper/helpplan.vm';
import { HelpPlanTypeVm } from 'app/_mapper/helpplantype.vm';
import { LocationVm } from 'app/_mapper/location.vm';

export class CauseVm {
    @AutoMap() ctyId: string;
    @AutoMap() ctyName: string;
    @AutoMap() ctyHasPiaPolicy: boolean;
    @AutoMap() ctyHasVecozoPolicy: boolean;
    @AutoMap() ctyHasPolicyStep: boolean;
    @AutoMap() ctyHasInsureeStep: boolean;
    @AutoMap() ctyHasCaseDetailsStep: boolean;
    @AutoMap() ctyHasTravelStep: boolean;
    @AutoMap() ctyHasFellowTravellersStep: boolean;
    @AutoMap() ctyHasAdlStep: boolean;
    @AutoMap() ctyHasDbcStep: boolean;
    @AutoMap() ctyHasHelpPlansStep: boolean;
    @AutoMap() ctyHasSummaryStep: boolean;
    @AutoMap() ctyHasActionsStep: boolean;
    @AutoMap() ctyHasLocationStep: boolean;
    @AutoMap() ctyCaseDetailId: string;
    @AutoMap() caseDetailLabel?: any;
    @AutoMap(() => LocationVm) locations: LocationVm[];
    @AutoMap(() => HelpPlanVm) helpPlans: HelpPlanVm[];
    @AutoMap(() => HelpPlanTypeVm) helpPlanTypes: HelpPlanTypeVm[];
    @AutoMap(() => ClientPolicyControlExceptionModelVm) clientPolicyControlExceptions: ClientPolicyControlExceptionModelVm[];
}

